import { AuthContext } from '../../Context'
import { useNavigate } from 'react-router-dom'
import { AuthContextApi } from '../../Context/api'
import { useContext, useEffect, useState } from 'react'
import Footer from '../../Components/Footer'
import { jsonConfig } from '../../Config'
import './index.css'

const LoginInvestidor = () => {
    const { states, setters } = useContext(AuthContext)
    const { loginInvestidor, loginStep2Investidor, checkLoginInvestidor } = useContext(AuthContextApi)
    const navigate = useNavigate()

    const [step, setStep] = useState(1)
    const [email, setEmail] = useState('')
    const [codigo, setCodigo] = useState('')
    const [errorEmail, setErrorEmail] = useState(false)
    const [msgErrorEmail, setMsgErrorEmail] = useState('O campo e-mail é obrigatório')
    const [errorCodigo, setErrorCodigo] = useState(false)

    const isValidEmail = (value) => /\S+@\S+\.\S+/.test(value)

    const handleStep1 = async () => {
        let error = false
        if (email === '') {
            setErrorEmail(true)
            setMsgErrorEmail('O campo e-mail é obrigatório')
            error = true
        } else if (!isValidEmail(email)) {
            setErrorEmail(true)
            setMsgErrorEmail('Insira um e-mail válido')
            error = true
        } else {
            setErrorEmail(false)
        }

        if (error) return

        const response = await loginInvestidor({ email })
        if (response) {
            setEmail('')
            setStep(2)
        }
    }

    const handleStep2 = async () => {
        if (codigo.trim() === '') {
            setErrorCodigo(true)
            return
        }
        setErrorCodigo(false)
        const response = await loginStep2Investidor({ codigo })
        if (response) {
            navigate('/investidor/investimentos')
        } else {
            setCodigo('')
            setStep(1)
        }
    }

    useEffect(() => {
        setters.setSigned(false)
        localStorage.removeItem('token')
        const check = async () => {
            const ok = await checkLoginInvestidor()
            if (ok) {
                setters.setSignedInvestidor(true)
                navigate('/investidor/investimentos')
            }
        }
        check()
    }, [])

    const getInputClass = (hasError) => {
        const base = 'w-full px-4 py-3 rounded-xl border text-sm transition-all duration-200 outline-none'
        if (states.isLoading) return `${base} border-gray-200 bg-gray-100 placeholder-gray-300 text-gray-400 cursor-not-allowed`
        if (hasError) return `${base} border-red-300 bg-red-50 placeholder-red-300 text-red-700 focus:border-red-400 focus:ring-2 focus:ring-red-200`
        return `${base} border-gray-200 bg-white placeholder-gray-400 text-gray-800 focus:border-brand-yellow focus:ring-2 focus:ring-brand-yellow/30`
    }

    return (
        <div className="min-h-screen flex">
            <div className="relative hidden lg:flex lg:w-1/2 xl:w-3/5 flex-col justify-end overflow-hidden bg-gray-950">
                <img
                    className="absolute inset-0 h-full w-full object-cover opacity-30"
                    src={jsonConfig.urlReact + '/background.jpeg'}
                    alt=""
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/50 to-transparent" />
                <div className="relative z-10 p-12 space-y-3">
                    <div className="w-10 h-1 rounded-full bg-brand-yellow" />
                    <h2 className="text-4xl font-bold text-white leading-tight">
                        Portal do Investidor
                    </h2>
                    <p className="text-gray-500 text-sm pt-2">
                        © {new Date().getFullYear()} MATRIZ MG — Área segura.
                    </p>
                </div>
            </div>

            <div className="flex flex-1 flex-col justify-center items-center px-8 py-12 bg-white">
                <div className="w-full max-w-sm">
                    <div className="mb-10 flex flex-col items-start gap-6">
                        <img className="h-14 w-auto" src={`${jsonConfig.urlReact}/logo.png`} alt="Matriz Mg Logo" />
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900">
                                {step === 1 ? 'Acesso do Investidor' : 'Validação em 2 Etapas'}
                            </h1>
                            <p className="mt-1 text-sm text-gray-400">
                                {step === 1
                                    ? 'Informe seu e-mail e senha para receber o código.'
                                    : 'Digite o código enviado para confirmar seu acesso.'}
                            </p>
                        </div>
                    </div>

                    <div className="space-y-5">
                        {step === 1 ? (
                            <>
                                <div>
                                    <label htmlFor="email-investidor" className="block text-sm font-medium text-gray-700 mb-1.5">E-mail</label>
                                    <input
                                        type="email"
                                        id="email-investidor"
                                        disabled={states.isLoading}
                                        value={email}
                                        onChange={(e) => {
                                            const v = e.target.value.trim()
                                            setEmail(v)
                                            if (v === '') {
                                                setErrorEmail(true)
                                                setMsgErrorEmail('O campo e-mail é obrigatório')
                                            } else {
                                                setErrorEmail(false)
                                            }
                                        }}
                                        onKeyDown={(e) => e.key === 'Enter' && handleStep1()}
                                        autoComplete="email"
                                        placeholder="seu@email.com"
                                        className={getInputClass(errorEmail)}
                                    />
                                    {errorEmail && <p className="text-red-500 text-xs mt-1.5">{msgErrorEmail}</p>}
                                </div>
                            </>
                        ) : (
                            <div>
                                <label htmlFor="codigo-investidor" className="block text-sm font-medium text-gray-700 mb-1.5">Código de verificação</label>
                                <input
                                    type="text"
                                    id="codigo-investidor"
                                    disabled={states.isLoading}
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleStep2()}
                                    placeholder="Digite o código recebido"
                                    className={getInputClass(errorCodigo)}
                                />
                                {errorCodigo && <p className="text-red-500 text-xs mt-1.5">O código é obrigatório</p>}
                            </div>
                        )}

                        <div className="pt-1 space-y-3">
                            <button
                                onClick={step === 1 ? handleStep1 : handleStep2}
                                type="button"
                                disabled={states.isLoading}
                                className="w-full flex justify-center items-center gap-3 py-3 px-4 rounded-xl text-sm font-bold text-gray-900 bg-brand-yellow hover:bg-brand-yellow-dark disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-yellow"
                            >
                                {states.isLoading && (
                                    <span className="h-4 w-4 rounded-full border-2 border-gray-900/20 border-t-gray-900 animate-spin" />
                                )}
                                {step === 1 ? 'Receber código' : 'Confirmar código'}
                            </button>

                            {step === 2 && (
                                <button
                                    onClick={() => {
                                        setStep(1)
                                        setCodigo('')
                                        setEmail('')
                                        setErrorCodigo(false)
                                        setErrorEmail(false)
                                    }}
                                    type="button"
                                    disabled={states.isLoading}
                                    className="w-full flex justify-center items-center py-3 px-4 rounded-xl text-sm font-medium text-gray-600 border border-gray-200 hover:bg-gray-50 disabled:opacity-50 transition-all duration-200"
                                >
                                    Voltar
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="mt-10 flex justify-center">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginInvestidor
